import { logout } from './requestLogoutActions';
import EventSender, { UserLoggedOutEvent } from '../../../services/trackevent';

export function requestLogout() {
  return (dispatch) => {
    EventSender.sendEvent(UserLoggedOutEvent());
    dispatch(logout());
    // TODO: Dispatch resetToLoginPage here
  };
}
